import { EdiFuncAckSeg } from "../EdiFuncAckSeg";
import { Checkbox, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiFuncAck extends Layout {
    checkboxTransmitted: Checkbox;
    labelStatus: Label;
    layoutFASeg: EdiFuncAckSeg;
    panelFA: Panel;
    sourceEdiFunctionalAck: DataSource;
    sourceEdiFunctionalSeg: DataSource;
    sourceEdiLog: DataSource;
    sourceEdistatus: DataSource;
    sourceViewEdiOrder: DataSource;
    textboxAk501TrxAckCd: Textbox;
    textboxAk902Sets: Textbox;
    textboxBatchId: Textbox;
    textboxCreateDate: Textbox;
    textboxEdiError: Textbox;
    textboxGSStatusCode: Textbox;
}
